export default "__VITE_ASSET__f5a02872__"